export let menuGroups = {
  clientId: '2b501946-9ba4-4fcb-a790-e4672b8c8c5c',
  groupDetails: [
    {
      groupName: 'ADD',
    },
    {
      groupName: 'NO',
    },
  ],
};
